<ng-multiselect-dropdown
  [placeholder]="'Choose'"
  [data]="filteredLanguages"
  [(ngModel)]="selectedItems"
  [settings]="langDropdownSettings"
  (onSelect)="onSelectLang($event)"
  (onDeSelect)="onDeSelectLang($event)"
  (onSelectAll)="onSelectAll($event)"
  (onDeSelectAll)="onSelectAll($event)"
  class="language-multi-select"
  [class.single-select]="singleSelection()">
</ng-multiselect-dropdown>
